<template>
  <div class="file-upload">
    <el-upload
      :action="uploadUrl"
      ref="upload"
      :show-file-list="false"
      :headers="uploadHeaders"
      :http-request="fnUploadRequest"
    >
      <!-- <el-button size="small" class="export" type="default">导入</el-button> -->
    </el-upload>
  </div>
</template>
<script>
import { Message } from "element-ui";
export default {
	name: "file-upload",
	data() {
		return {
			uploadUrl: "",
			uploadHeaders: {"X-Account-ID": this.$store && this.$store.state && this.$store.state.user && this.$store.state.user.account},
		};
	},
	methods: {
		fnUploadRequest(e){
			this.$emit("callbackResults", e);
		}
	}
};
</script>
